var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.839 5.982a1 1 0 00-1.49.872v18.289a1 1 0 001.49.872L26.14 16.87a1 1 0 000-1.744L9.839 5.982zm-3.49.872c0-2.293 2.469-3.738 4.468-2.617l16.302 9.145c2.043 1.146 2.043 4.087 0 5.233l-16.302 9.144c-2 1.122-4.467-.323-4.467-2.616V6.854z",
    fill: "currentColor"
  })));
}
export default SvgPlay;